/* eslint-disable react/no-danger */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import update from 'react-addons-update';
import { connect } from 'react-redux';
import { FormGroup, Label, Input } from 'reactstrap';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../Order.sass';
import {
  setNeedCart,
  setCartCount,
  setNeedCarry,
  setPayByReceiver,
  updateOrderDetailInfoAction,
} from '../../../actions/order';

class Order12AddDetail extends React.Component {
  static propTypes = {
    modelData: PropTypes.shape().isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
    orderDetailInfo: PropTypes.shape().isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      service: [],
    };
  }

  componentWillMount() {
    for (
      let i = 0;
      i <
      this.props.modelData.additional_service[
        this.props.orderDetailInfo.service_type
      ].length;
      i += 1
    ) {
      const currentObject = this.props.modelData.additional_service[
        this.props.orderDetailInfo.service_type
      ][i];
      if (typeof currentObject.ignore !== 'undefined' && currentObject.ignore) {
        //
      } else {
        this.setState({
          service: update(this.state.service, {
            $push: [false],
          }),
        });
      }
    }
  }

  render() {
    return (
      <div>
        <div
          className={`${s2.orderAdditionalService} ${
            s2.orderAdditionalService
          }`}
        >
          {this.props.modelData.additional_service[
            this.props.orderDetailInfo.service_type
          ].map((service, index) => (
            <div
              key={index.toString()}
              style={
                typeof service.ignore !== 'undefined' && service.ignore
                  ? { display: 'none' }
                  : {}
              }
            >
              <FormGroup className={s2.formGroupMarginTop} check>
                <Label check>
                  <Input
                    type="checkbox"
                    name={
                      ['is_raining', 'is_snowing'].includes(
                        service.service_code,
                      )
                        ? 'group'
                        : service.title
                    }
                    checked={this.state.service[index]}
                    onClick={() => {
                      this.props.updateOrderDetailInfoAction(
                        'order_request_detail_attributes',
                        service.service_code,
                        !this.state.service[index],
                      );
                      if (service.service_code === 'is_raining') {
                        this.state.service[1] = false;
                        this.props.updateOrderDetailInfoAction(
                          'order_request_detail_attributes',
                          'is_snowing',
                          false,
                        );
                      }
                      if (service.service_code === 'is_snowing') {
                        this.state.service[0] = false;
                        this.props.updateOrderDetailInfoAction(
                          'order_request_detail_attributes',
                          'is_raining',
                          false,
                        );
                      }
                      this.setState({
                        service: update(this.state.service, {
                          [index]: { $set: !this.state.service[index] },
                        }),
                      });
                      this.forceUpdate();
                    }}
                  />&nbsp;
                  <span
                    role="button"
                    tabIndex={0}
                    className={`${s2.orderAdditionalService} ${s2.label}`}
                    htmlFor="true"
                    dangerouslySetInnerHTML={{ __html: service.title }}
                    onClick={() => {
                      // this[service.title] = !this[service.title];
                      this.props.updateOrderDetailInfoAction(
                        'order_request_detail_attributes',
                        service.service_code,
                        this.state.service[index],
                      );
                    }}
                    onKeyPress={() => {}}
                  />
                </Label>
              </FormGroup>
              {service.options.length > 0 && this.state.service[index] ? (
                <div className={`${s2.labelAdditionalOption}`}>
                  {service.options.map((o, i) => (
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name={service.service_code}
                          onClick={() => {
                            this[o.title] = !this[o.title];
                            this.props.updateOrderDetailInfoAction(
                              'order_request_detail_attributes',
                              o.option_name,
                              o.option_code,
                            );
                            this.forceUpdate();
                          }}
                          defaultChecked={i === 0}
                        />&nbsp;
                        <span
                          role="button"
                          tabIndex={0}
                          className={`${s2.orderAdditionalService} ${s2.label}`}
                          htmlFor="true"
                          dangerouslySetInnerHTML={{ __html: o.title }}
                          onClick={() => {
                            this[o.title] = !this[o.title];
                            this.props.updateOrderDetailInfoAction(
                              'order_request_detail_attributes',
                              o.option_name,
                              o.option_code,
                            );
                            this.forceUpdate();
                          }}
                          onKeyPress={() => {}}
                        />
                      </Label>
                    </FormGroup>
                  ))}
                </div>
              ) : (
                ''
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
const mapState = state => ({
  need_carry: state.order.need_carry,
  pay_by_receiver: state.order.pay_by_receiver,
  orderDetailInfo: state.order.orderDetailInfo,
});

const mapDispatch = {
  setNeedCart,
  setCartCount,
  setNeedCarry,
  setPayByReceiver,
  updateOrderDetailInfoAction,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order12AddDetail),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order12AddService/Order12AddServiceDetailKR.js